var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrans10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 28,
    r: 27.5,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7708 28.3561C31.2006 28.3561 34.7917 24.7651 34.7917 20.3353C34.7917 15.9055 31.2006 12.3145 26.7708 12.3145C22.341 12.3145 18.75 15.9055 18.75 20.3353C18.75 24.7651 22.341 28.3561 26.7708 28.3561Z",
    fill: "#01A926"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5208 30.8262C32.6537 30.8262 30.3262 33.1537 30.3262 36.0208C30.3262 38.8878 32.6537 41.2168 35.5208 41.2168C38.3878 41.2168 40.7168 38.8878 40.7168 36.0208C40.7168 33.1537 38.3878 30.8262 35.5208 30.8262ZM35.5208 33.0137C37.1803 33.0137 38.5293 34.3612 38.5293 36.0208C38.5293 37.6803 37.1803 39.0293 35.5208 39.0293C33.8612 39.0293 32.5122 37.6803 32.5122 36.0208C32.5122 34.3612 33.8612 33.0137 35.5208 33.0137Z",
    fill: "#01A926"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6143 31.9192V29.459C36.6143 28.8552 36.1243 28.3652 35.5205 28.3652C34.9168 28.3652 34.4268 28.8552 34.4268 29.459V31.9207C34.4268 32.5229 34.9168 33.0144 35.5205 33.0144C36.1243 33.0129 36.6143 32.5229 36.6143 31.9192Z",
    fill: "#01A926"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4268 40.1221V42.5837C34.4268 43.1875 34.9168 43.6775 35.5205 43.6775C36.1243 43.6775 36.6143 43.1875 36.6143 42.5837V40.1221C36.6143 39.5198 36.1243 39.0298 35.5205 39.0283C34.9168 39.0283 34.4268 39.5198 34.4268 40.1221Z",
    fill: "#01A926"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8474 38.1475L30.1076 39.8888C29.6803 40.3146 29.6803 41.0087 30.1076 41.4346C30.5334 41.8619 31.2276 41.8619 31.6534 41.4346L33.3947 39.6948C33.8205 39.2675 33.8205 38.5748 33.3947 38.1475C32.9674 37.7217 32.2747 37.7217 31.8474 38.1475Z",
    fill: "#01A926"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4182 34.9277H28.958C28.3543 34.9277 27.8643 35.4177 27.8643 36.0215C27.8643 36.6252 28.3543 37.1152 28.958 37.1152H31.4182C32.022 37.1152 32.5134 36.6252 32.512 36.0215C32.512 35.4177 32.022 34.9277 31.4182 34.9277Z",
    fill: "#01A926"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3947 32.3474L31.6534 30.6076C31.2276 30.1803 30.5334 30.1803 30.1076 30.6076C29.6803 31.0334 29.6803 31.7276 30.1076 32.1534L31.8474 33.8947C32.2747 34.3205 32.9674 34.3205 33.3947 33.8947C33.8205 33.4674 33.8205 32.7747 33.3947 32.3474Z",
    fill: "#01A926"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8648 42.2279C28.0861 41.2274 28.1561 39.7764 29.0763 38.8577L29.3592 38.5733H28.9582C27.5494 38.5733 26.4061 37.4299 26.4061 36.0212C26.4061 34.6124 27.5494 33.4691 28.9582 33.4691H29.3592L29.0763 33.1847C28.1196 32.2295 28.0817 30.6997 28.9625 29.6979C28.248 29.6424 27.5159 29.6133 26.7707 29.6133C21.9261 29.6133 17.6371 30.8252 14.9742 32.6408C12.9428 34.0262 11.8228 35.7864 11.8228 37.6341V39.7487C11.8228 40.4064 12.0838 41.0379 12.549 41.5016C13.0142 41.9668 13.6442 42.2279 14.3019 42.2279H28.8648Z",
    fill: "#01A926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrans10);
export default __webpack_public_path__ + "static/media/trans10.f17e65444fe6356432c81be5e4dfb079.svg";
export { ForwardRef as ReactComponent };